module.exports = __webpack_public_path__ + "img/img_measure_a.16995967.svg";